import "./ClassicyTextEditor.scss";
import React from "react";

interface EditorProps {
  content: string;
}

export const ClassicyTextEditor: React.FC<EditorProps> = ({ content }) => {
  return (
    <div className="classicyTextEditorWrapper">
      <textarea className="classicyTextEditor" value={content} readOnly />
    </div>
  );
};
